"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var styled_components_1 = require("styled-components");
var SituationSelectOption_1 = require("../SituationSelectModal/SituationSelectOption");
function createOptions(props) {
    var elements = [];
    for (var _i = 0, _a = props.options.options; _i < _a.length; _i++) {
        var option = _a[_i];
        elements.push(React.createElement(SituationSelectOption_1.SituationSelectOption, { key: option.id, option: option, selected: props.selected, onSelect: props.onSelect }));
    }
    return elements;
}
exports.SituationSelectOptions = function (props) {
    return React.createElement(OptionsContent, null, createOptions(props));
};
var OptionsContent = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  top: 100px;\n  bottom: 60px;\n  background-color: #eee;\n"], ["\n  position: absolute;\n  overflow: auto;\n  width: 100%;\n  top: 100px;\n  bottom: 60px;\n  background-color: #eee;\n"])));
var templateObject_1;
